import { render, staticRenderFns } from "./TwoColumnsContainerLoader.vue?vue&type=template&id=81372eb6&scoped=true&"
import script from "./TwoColumnsContainerLoader.vue?vue&type=script&lang=ts&"
export * from "./TwoColumnsContainerLoader.vue?vue&type=script&lang=ts&"
import style0 from "./TwoColumnsContainerLoader.vue?vue&type=style&index=0&id=81372eb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81372eb6",
  null
  
)

export default component.exports